/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 * ======================================================================== */

import { camelCase } from "./camel-case";

export type Route = {
	init: () => void;
	finalize: () => void;
};

type Routes = {
	[key: string]: Route;
};

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
export class Router {
	routes: Routes;

	constructor(routes: Routes) {
		this.routes = routes;
	}

	// TODO: fix the underlying @typescript-eslint/no-explicit-any issue
	// eslint-disable-next-line
	fire(route: string, functionToFire = "init", functionArguments?: any) {
		const fire =
			route !== "" &&
			this.routes[route] &&
			typeof this.routes[route][functionToFire] === "function";
		if (fire) {
			this.routes[route][functionToFire](functionArguments);
		}
	}

	loadEvents() {
		// Fire common init JS
		this.fire("common");

		// Fire page-specific init JS, and then finalize JS
		const classNames = document.body.className
			.toLowerCase()
			.replaceAll("-", "_")
			.split(/\s+/)
			.map((className) => camelCase(className));

		for (const className of classNames) {
			this.fire(className);
			this.fire(className, "finalize");
		}

		// Fire common finalize JS
		this.fire("common", "finalize");
	}
}
